import get from 'lodash/get';
import { getClmsJsonApi, getCompareWithListApi } from 'library-@/apis/core_basic_api/patent';
import { getObjectBylang } from '../utils';
import Service from './Service';
import { getParams, excludes } from '@/lib/api/index';

export default class ClaimService extends Service {
    constructor(patentId) {
        super();
        this.patentId = patentId;
        this.lang = 'en';
        this.worker = undefined;
    }

    async getPatentClaim(PN) {
        const { data, params } = await getParams({ excludes });
        const resp = await getClmsJsonApi({ patentId: this.patentId, pn: PN, data, params });
        const _data = get(resp, 'data.data', {});
        const { CLMS, CLMS_LANG, LANG_DEFAULT } = _data;
        const lang = CLMS_LANG || LANG_DEFAULT;
        this.lang = lang;
        const text = getObjectBylang(CLMS, lang);
        return { text, lang, ..._data };
    }

    getCompareWithList() {
        return getCompareWithListApi({
            patentId: this.patentId,
            lang: this.lang,
            type: 'clms'
        });
    }
}
